<template>
	<!-- 进出记录-->
	<div class="fuzzy-matching-box">
		<div class="fuzzy-matching-top">
			<el-form @keyup.native.enter="inquiryClick">
				<el-row class="top-first-line">
					<el-col :span="5">
						<el-form-item label="名称:">
							<el-input v-model="Dform.name" placeholder='请输入关键词'></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="楼栋:">
						<el-select v-model="schoolListTopId" placeholder="请选择楼栋" @change="LouDongBtn">
							<el-option :label="item.name" :value="item.id" v-for="item in LouData"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="宿舍:">
						<el-select v-model="SusheId" placeholder="请选择宿舍" @change="SUsheBtn">
							<el-option :label="item.name" :value="item.id" v-for="item in SusheData"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="状态:">
						<el-select v-model="statusId" placeholder="请选择进出状态" @change="LouDongBtn">
							<el-option :label="item.label" :value="item.value" v-for="item in statuData"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
					</el-col>
				</el-row>
				<el-row class="top-first-line">
					<el-col :span="5">
						<el-form-item label="开始:">
							<el-date-picker v-model="startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
							value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择开始时间">
							</el-date-picker>
						</el-form-item>
						</el-col>
						<el-col :span="5">
						<el-form-item label="结束:">
							<el-date-picker v-model="terminalTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
							value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择结束时间">
							</el-date-picker>
						</el-form-item>
						</el-col>
					
					<el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
				</el-row>

			</el-form>
		</div>


		<!-- table表格 -->
		<div class="Table-Bottom">
			<el-table v-loading="loading" stripe :border="true"
				:header-cell-style="{ background: '#EDF6FF', color: '#000', height: '40px' }" ref="multipleTable"
				:data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" label="序号" width="100">
				</el-table-column>
				<el-table-column prop="studentName" label="学生名称" >
				</el-table-column>
                <el-table-column prop="className" label="年级/班级" >
				</el-table-column>
                <el-table-column prop="dormitoryName" label="房间号" >
				</el-table-column>
				<el-table-column prop="studentCount" label="进/出" >
					<template #default="scope">
						<span v-if="scope.row.status == 0">进</span>
						<span v-if="scope.row.status == 1">出</span>
					</template>
				</el-table-column>
				<el-table-column  label="打卡照片" >
					<template #default="scope">
							<img class="head_img"  src="../../../images/defult_man.jpeg" alt="" v-if="scope.row.facePic == null">
							<img :src="scope.row.facePic" alt="" @click="lookImage(scope.row.facePic)" style="width: 60px;height: 60px ;"v-else>
					</template>
				</el-table-column>
				<el-table-column prop="imei" label="打卡设备IMEI" >
				</el-table-column>
				<el-table-column prop="createDate" label="打卡时间" >
				</el-table-column>
z

			</el-table>
            <div class="block-fenye">
             <el-pagination :small="small" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
               :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
           </div>
		</div>
		<ImageView v-if="imageView" @addClick="addClick" :titleValue="titleValue" :pathPic="pathPic" />

	</div>
</template>
<!--  -->
<script>
	import {
        RecordList,
		SusheDormitoryList,
		LoDongBuildingList
	} from '@/assets/api/schoollog.js'
    import {
		findTeacherInfo,
	} from '@/assets/api/renyuan';
	import ImageView from './ImageView.vue'

	export default {
		components: {
			ImageView

		},
		data() {
			return {
				imageView:false,
				Dform: {
					name: ''
				},

				pageInfo: {
					page: 1,
					pageSize: 10,
				},
				multipleSelection: [],
				LouData:[],
				SusheData:[],
				tableData: [],
                schoolInfo:{},
				statuData:[
					{value:0,
					 label:'进'
					},
					{value:1,
					 label:'出'
					},
				],
				total: 0,
				twigMax: 0,
				twigMin: 0,
				schoolListTopId:'',
				SusheId:'',
				startTime:'',
				terminalTime:'',
				statusId:'',
				loading:true
			

			}
		},
		created() {
			this.Lookteacher()
			
			// this.menuGetUserTreeGet()
		},
		methods: {
           // 查看学校id 
            Lookteacher() {
                let params = {
                    userId: JSON.parse(localStorage.getItem('user')).id,
                }
                findTeacherInfo(params).then((res) => {
                    this.schoolInfo = res.data.data
					if (this.schoolInfo.schoolId) {
						this.getList()
						this.handleChange()
						this.susheChange()
					}else{
						this.loading = false
						this.$message({
								message: '该账号没有权限，请登录学校账号！',
								type: 'warning'
							});
			}

					
                }).catch((err) => {
                    console.log(err);
                })
            },
			getList(){
				let params = {
					endTime:this.terminalTime,
					startTime:this.startTime,
					buildingId:this.schoolListTopId,
					dormitoryId:this.SusheId,
                    schoolId: this.schoolInfo.schoolId,
                    studentName:this.Dform.name,
                    status:this.statusId,
                    page:this.pageInfo.page,
                    pageSize:this.pageInfo.pageSize,
					
                }
                RecordList(params).then((res) => {
                 this.tableData = res.data.data.list
				 this.total = res.data.data.total
				this.loading = false

                }).catch((err) => {
                    console.log(err);
					this.$message({
					type: 'error',
					message: err.response.data.msg || '接口异常'
				});
                })
			},
			//宿舍下拉列表
            susheChange(){
                let params = {
					buildingId:this.schoolListTopId,
                    schoolId: this.schoolInfo.schoolId,
                    name:this.Dform.name,
                    page:this.pageInfo.page,
                    pageSize:this.pageInfo.pageSize,
                }
                SusheDormitoryList(params).then((res) => {
                    this.SusheData = res.data.data.list
                }).catch((err) => {
                    console.log(err);
                })

            },
			//楼栋下拉列表
			handleChange(){
				console.log('1ppppp');
				
				let params = {
                    schoolId: this.schoolInfo.schoolId,
                    name:this.Dform.name,
                    page:this.pageInfo.page,
                    pageSize:'9999',
                }
                LoDongBuildingList(params).then((res) => {
					this.LouData = res.data.data.list
					
                }).catch((err) => {
                    console.log(err);
                })
			},
			lookImage(file){
				this.pathPic = file;
				this.titleValue="考勤照片";
				this.imageView = true;
			},
			
			addClick() {
				this.imageView = false
			},
			inquiryClick() {
				if (this.schoolInfo.schoolId) {
					this.getList()

				}else{
						this.loading = false
						this.$message({
								message: '该账号没有权限，请登录学校账号！',
								type: 'warning'
						});
				}


			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.getList()
			},

		}
	}
</script>

<!-- porimse -->
<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 20px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 95%;
		background-color: #fff;
		border-radius: 8px;
		.fuzzy-matching-top {
			// height: 120px ;
			background-color: #fff;
			border-radius: 8px;

			/deep/ {
					.el-row {
						margin-top: 20px;
					}
				}
			.top-first-line {
				/deep/ {

					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

					.el-button--small {
						width: 50px;
						height: 30px;
						margin-left: 20px;
						margin-top: 3px;
					}

					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}


			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				
			}
			.query-button {
					position: absolute;
					right: 830px;
					// padding: 16px 24px;
					// width: 50px;
					// height: 50px !important;
					// top: 50%;
					// transform: translate(0,-50%);
				}
			/deep/ {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}

			}

			.el-button--text {
				margin-left: 50px;
				margin-top: 10px;
				font-size: 16px;
			}
		}

        .block-fenye {
        // float: right;
            position: absolute;
            //   bottom: 0px;
            right:10%;
            top: 85%;
            transform: translate(-50%, 0);

        }
		.Table-Bottom {
			height: calc(100% - 110px);
			overflow: auto;
			// position: relative;
			padding: 0px 20px;
			padding-top: 20px;
			// margin-top: 15px;
			border-radius: 8px;

			.head_img{
				max-width: 30px;
				max-height: 60px;
				object-fit: cover;
			}
			/deep/ {
				.el-table .cell {
					// font-size: 15px;
					font-size: 16px;
					color: black;
					// font-weight: 700;
					text-align: center;
                    height: 30px;
                    line-height: 30px;
				}

				.el-table th.el-table__cell>.cell {
					font-weight: 700;
				}
			}

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;

			}

			.shanchuBtn {
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}
		}

		
	}
</style>
